<template>
  <div class="animated fadeIn personal-list">
    <app-filtro
      :nombre="nombre"
      :incluirInactivos="Boolean(incluirInactivos)"
      incluirInactivosLeyenda="Incluir todas los personas (inactivas)"
      @filtrar="filtrar">
    </app-filtro>  

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Personal">
          <b-form>
            <b-form-group
              label="Buscar"
              label-for="nombreBusqueda"
              :label-cols="1"
              horizontal>
              <b-form-input id="nombreBusqueda" 
                v-model= "nombreBusqueda" 
                type="text">
              </b-form-input>
            </b-form-group>
          </b-form>

          <b-table 
              :class="{ 'registro': true, 'inactivos': (/true/i).test(incluirInactivos) }" 
              responsive="sm" 
              :items="personal" 
              :fields="itemFields"
              :filter="nombreBusqueda"
              :current-page="paginaActual"
              :per-page="registrosPorPagina"
              @filtered="onFiltered"
              @row-clicked="consultar"
              :busy="tableBusy">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(fechaIngreso)="data">
              {{ data.item.fechaIngreso | fecha }}
            </template>
            <template v-slot:cell(fechaEgreso)="data">
              {{ data.item.fechaEgreso | fecha }}
            </template>
            <!-- <template v-slot:cell(fechaActualizacionLegajo)="data">
              {{ data.item.fechaActualizacionLegajo | fecha }}
            </template>
            <template v-slot:cell(honorarios)="data">
              {{ data.item.honorarios | moneda }}
            </template>
            <template v-slot:cell(adicional)="data">
              {{ data.item.adicional | moneda }}
            </template> -->

            <template v-slot:cell(opciones)="data" v-if="accesoEdit">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Legajo</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar" v-if="accesoAdd">
            <i class="fa fa-plus"></i>Agregar Personal</b-dropdown-item>

          <b-dropdown-item @click.stop="exportarListado">
            <i class="fa fa-file-excel-o"></i>Exportar Listado de Personal</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>

    <!--
    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
      <div class="data-xls-btn" @click.prevent="exportXLS">
          <i class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
      </div>
    </div>
    -->
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import export_xls from '../../mixins/export_xls';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'personel/getField',
  mutationType: 'personel/updateField',
});

export default {
  name: 'Personal',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    export_xls,
    msjModal, 
    confirmModal 
  ],
  data() {
    return {
      loaded: false,
      tableBusy: false,

      accesoAdd: false,
      accesoEdit: false,
      accesoConsultar: false
    }
  },
  computed: {
    ...mapFields([
      'personal',
      'nombre',
      'incluirInactivos',
      'nombreBusqueda',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
    itemFields() {
      let fields = [
        {
          key: 'nombreCompleto',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'fechaIngreso',
          label: 'Fecha Ingreso',
        }
      ];

      if ((/true/i).test(this.incluirInactivos)) {
        fields.push({
          key: 'fechaEgreso',
          label: 'Fecha Egreso',
        });
      }

      fields.push({
          key: 'cargo',
          sortable: true
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      );

      return fields;
    } 
  },
  created() {
    let route = this.$router.resolve({ name: 'PersonalAdd' }).route;
    this.accesoAdd = Boolean(this.$store.getters['user/tieneAcceso'](route));
    route = this.$router.resolve({ name: 'PersonalEdit', params: { id: -1 } }).route;
    this.accesoEdit = Boolean(this.$store.getters['user/tieneAcceso'](route));
    route = this.$router.resolve({ name: 'PersonalDatos', params: { id: -1 } }).route;
    this.accesoConsultar = Boolean(this.$store.getters['user/tieneAcceso'](route));

    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('personel/getPersonal')
        .then(() => this.tableBusy = false)
        .catch( error => this.showErrorMsj (error));
    },
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.incluirInactivos = filtro.incluirInactivos;
      this.nombreBusqueda = '';
      this.paginaActual = 1;

      this.getItems()
    },    
    consultar (item) {
      if (this.accesoConsultar) {
        this.$router.push({ name: 'PersonalDatos', 
                            params: { id: item.id }});
      }
    },
    editar (item) {
      if (this.accesoEdit) {
        this.$router.push({ name: 'PersonalEdit', 
                            params: { id: item.id }});
      }
    },
    // borrar (item) {
    //   this.modalDisabled = true;
    // },
    agregar () {
      if (this.accesoAdd) {
        this.$router.push({ name: 'PersonalAdd' });
      }
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    },
    exportarListado() {
      if (this.personal) {
        let title= 'Listado de Personal';
        let fileName = 'personal';
        let format = [
          { titulo: 'Nombre', nombre: 'nombreCompleto', formato: '' },
          { titulo: 'Fecha Ingreso', nombre: 'fechaIngreso', formato: 'fecha' },
          { titulo: 'Fecha Egreso', nombre: 'fechaEgreso', formato: 'fecha' },
          { titulo: 'Cargo', nombre: 'cargo', formato: '' },
        ];

        this.exportXLS(title, fileName, this.personal, format);
      } else {
        this.showModalMsj ('No hay datos para exportar.', null, null, 'danger');
      }
    },                
  },
}
</script>

<style>
  .personal-list table td[aria-colindex="1"] {
    width: calc(55% - 60px);
  }
  .personal-list table td[aria-colindex="2"] {
    width: 15%;
  }
  .personal-list table td[aria-colindex="3"] {
    width: 30%;
  }
  .personal-list table td[aria-colindex="4"] {
    width: 60px;
  }

  .personal-list .inactivos table td[aria-colindex="1"] {
    width: calc(40% - 60px);
  }
  .personal-list .inactivos table td[aria-colindex="2"] {
    width: 15%;
  }
  .personal-list .inactivos table td[aria-colindex="3"] {
    width: 15%;
  }
  .personal-list .inactivos table td[aria-colindex="4"] {
    width: 30%;
  }
  .personal-list .inactivos table td[aria-colindex="5"] {
    width: 60px;
  }


</style>
